var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center pb-1 pr-6",class:{ 'cursor-pointer': ! _vm.read_only },on:{"click":_vm.select}},[_c('div',{staticClass:"border flex-none rounded-full transition-colors duration-100",class:[
            _vm.sizeClasses,
            { 'read_only': _vm.read_only },
            { 'on': _vm.selected },
            { 'off': ! _vm.selected },
        ]}),_vm._v(" "),_c('label',{staticClass:"font-semibold text-gray-700 text-label leading-none select-none",class:{ 'cursor-pointer': ! _vm.read_only }},[_vm._v("\n         "+_vm._s(_vm.$t(_vm.label))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }